export default "__VITE_ASSET__baf89367__"